import { Component, Input } from '@angular/core';
import { BlockModel } from '../../../../PageBuilder/models/block.model';
import { AbstractPageBuilderService } from '../../../../PageBuilder/services/abstract-page-builder.service';
import { ReportBlockTypeEnum, reportChartInfoMap } from '../../../enums/report-block-type.enum';
import { ReportsPageBuilderService } from '../../../services/reports-page-builder.service';
import { ReportsService } from '../../../services/reports.service';

// To export pdf of shared report, we need to use this component render the charts first
// You would not see this component in the screen as we intentionally set its width and height to 1px
@Component({
    selector: 'agpr-shared-reports-export',
    templateUrl: './shared-reports-export.component.html',
    styleUrls: ['./shared-reports-export.component.scss'],
    providers: [
        {
            provide: AbstractPageBuilderService,
            useExisting: ReportsPageBuilderService,
        }
    ],
    standalone: false
})
export class SharedReportsExportComponent {

    @Input() set blocks(blocks: BlockModel[]) {
        this.reportsService.setNewReport();
        blocks.forEach(block => this.setBlockSize(block));
        this.pageBuilderService.setBlocks(blocks);
    };

    @Input() name = '';

    constructor (
        public pageBuilderService: ReportsPageBuilderService,
        private reportsService: ReportsService
    ) { }

    /**
     * set block cols and rows
     */
    setBlockSize(block: BlockModel): void {
        if (!block?.type?.key) {
            return;
        }

        block.cols = Math.max(reportChartInfoMap.get(block.type.key as ReportBlockTypeEnum).dimensions.width, 3);
        block.rows = Math.max(reportChartInfoMap.get(block.type.key as ReportBlockTypeEnum).dimensions.height, 3);
    }
}
